"use client"
import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { Form, Card, Button, Collapse } from "react-bootstrap";

import "@/components/maps/embed/EmbeddedLayerView.css";
import useUtils from "@/components/shared/useUtils";

const EmbeddedLayerView = ({
  onClose,
  layers,
  onLayerChange,
  showLayerView,
  enabledLayers
}) => {
  const utils = useUtils();
  const DEFAULT_COLOR = "0F839D";
  const [selectedLayers, setSelectedLayers] = useState([]);
  const [cardClass, setCardClass] = useState("hide");
  const [showNeighborhoodToggle, setShowNeighborhoodToggle] = useState(false);
  const [showRouteToggle, setShowRouteToggle] = useState(false);

  const isSm = useMediaQuery({ maxWidth: "767.98px" });

  useEffect(() => {
    if (enabledLayers) {
      setSelectedLayers(enabledLayers);
    }
    if (showLayerView) {
      setCardClass("expand-layer-view");
    } else {
      setCardClass("hide");
    }
  }, [enabledLayers, showLayerView]);

  const onSwitchToggled = (value, checked) => {
    // console.log("EmbeddedLayerView onSwitchToggled", layers,selectedLayers,value,checked);
    var newSelectedLayers = [...selectedLayers];
    if (checked) {
      var layerAndChildren = layers.filter(lyr => lyr.value.startsWith(value));
      newSelectedLayers = newSelectedLayers.concat(
        layerAndChildren.map(lyr => lyr.value)
      );
    } else {
      newSelectedLayers = newSelectedLayers.filter(
        lyr => !lyr.startsWith(value)
      );
    }
    onLayerChange(newSelectedLayers);
  };

  return (
    <div
      className={`
        embedded-layer-card
        h-100
        ${cardClass}
      `}
    >
      <Card className="h-100">
        <Card.Body className="d-flex flex-column justify-content-start align-items-center p-0 h-100">
          <div className="content-layer-container flex-grow-1">
            <div className="d-flex flex-row justify-content-start align-items-center w-100 layer-div">
              <h4 className="layer-label">Map Layers</h4>
              <div className="flex-grow" />
              <span
                className="material-icons ml-auto mr-0"
                style={{ cursor: "pointer", color: "#AFB0B0" }}
                onClick={onClose}
              >
                close
              </span>
            </div>
            {layers &&
              layers
                .filter(
                  lyr =>
                    !lyr.value.startsWith("BUSINESSES.") &&
                    !lyr.value.startsWith("POI.")
                )
                .map(function(layer, index) {
                  var checked =
                    selectedLayers.findIndex(sl => sl === layer.value) > -1;
                  return (
                    <>
                      <div className="d-flex flex-row justify-content-start align-items-center w-100 layer-div">
                        <img
                          className="layer-marker"
                          src={utils.markerUrl(layer.layerMarkerRef ?? DEFAULT_COLOR, layer.icon, layer.shape ?? "PIN")}
                          style={{ marginRight: "1rem" }}
                        />
                        <span
                          className={
                            "layer-label" + (checked ? " checked" : "")
                          }
                        >
                          {layer.label}
                        </span>
                        <div className="flex-grow-1" />
                        <Form.Check
                          className={
                            "layer-switch" + (checked ? " checked" : "")
                          }
                          custom="true"
                          type="switch"
                          checked={checked}
                          id={`${layer.value}-switch`}
                          onClick={evt => {
                            onSwitchToggled(layer.value, !checked);
                          }}
                          label=""
                        />
                      </div>
                      {(layer.value === "BUSINESSES" ||
                        layer.value === "POI") && (
                        <Collapse in={checked}>
                          <div>
                            {layers
                              .filter(
                                lyr =>
                                  lyr.value.startsWith(`${layer.value}.`) &&
                                  lyr.filterable
                              )
                              .map(function(layer, index) {
                                var check =
                                  selectedLayers.findIndex(
                                    sl => sl === layer.value
                                  ) > -1;
                                return (
                                  <div className="d-flex flex-row justify-content-start align-items-center w-100 layer-div">
                                    <img
                                      className="layer-marker"
                                      src={utils.markerUrl(layer.layerMarkerRef ?? DEFAULT_COLOR, layer.icon, layer.shape ?? "PIN")}
                                      style={{
                                        marginRight: "1rem",
                                        marginLeft: "2rem"
                                      }}
                                    />
                                    <span
                                      className={
                                        "layer-label" +
                                        (check ? " checked" : "")
                                      }
                                    >
                                      {layer.label}
                                    </span>
                                    <div className="flex-grow-1" />
                                    <Form.Check
                                      className={
                                        "layer-switch" +
                                        (check ? " checked" : "")
                                      }
                                      custom="true"
                                      type="switch"
                                      checked={check}
                                      id={`${layer.value}-switch`}
                                      onClick={evt => {
                                        onSwitchToggled(layer.value, !check);
                                      }}
                                      label=""
                                    />
                                  </div>
                                );
                              })}
                          </div>
                        </Collapse>
                      )}
                    </>
                  );
                })}
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default EmbeddedLayerView;
